export default "__VITE_ASSET__c229719d__"